// Copyright (c) Ensho Health, 2021 to present

import api from '../api';
import { setNotification, NOTIFICATION_TYPES } from './notification.action.js';

const PREFIX = 'user';
export const ACTION_TYPES = {
  SET_USER: `${PREFIX}-SET_USER`,
  COMPLETE_SETUP: `${PREFIX}-COMPLETE_SETUP`,
  COMPLETE_CLINIC_SETUP: `${PREFIX}-COMPLETE_CLINIC_SETUP`,
  LOADING: `${PREFIX}-LOADING`,
  ERROR: `${PREFIX}-ERROR`
};

function isSupervisorInRoles(roles) {
  const supervisorRegex = /supervisor|administrator/i;
  const rolesAsString = roles.join(' ');
  return supervisorRegex.test(rolesAsString);
}
function isAdministratorInRoles(roles) {
  return (
    roles.includes('Clinic Administrator') ||
    roles.includes('Ensho Administrator')
  );
}
function getMustSetupClinic(user) {
  return !user.clinic.setupComplete && user.userId === user.clinic.setupUser;
}

export function fetch() {
  return async (dispatch) => {
    try {
      dispatch({ type: ACTION_TYPES.LOADING });
      const user = await api.user.fetchUser();
      const isSupervisor = isSupervisorInRoles(user?.roles || []);
      const isAdministrator = isAdministratorInRoles(user?.roles || []);
      const mustSetupClinic = getMustSetupClinic(user);
      dispatch({
        type: ACTION_TYPES.SET_USER,
        payload: { ...user, isSupervisor, isAdministrator, mustSetupClinic }
      });
    } catch (error) {
      console.error(error.message);
      dispatch(
        setNotification({
          type: NOTIFICATION_TYPES.ERROR,
          serverMessage: error.message,
          info: { location: 'user.action.fetch' },
          display:
            'Error while fetching your information. Please reload the page.'
        })
      );
      dispatch({ type: ACTION_TYPES.ERROR, payload: error.message });
    }
  };
}

export function completeSetup(info) {
  return async (dispatch, getState) => {
    try {
      const userId = getState().user.data.userId;
      if (userId) {
        info.userId = userId;
        dispatch({ type: ACTION_TYPES.LOADING, payload: true });
        await api.user.setupUser(info);
        dispatch({ type: ACTION_TYPES.COMPLETE_SETUP, payload: info });
      } else {
        throw new Error('No user ID');
      }
    } catch (error) {
      console.error(error.message);
      dispatch(
        setNotification({
          type: NOTIFICATION_TYPES.ERROR,
          serverMessage: error.message,
          info: { location: 'user.action.completeSetup' },
          display: 'Error while completing your profile. Please try again.'
        })
      );
      dispatch({ type: ACTION_TYPES.ERROR, payload: error.message });
    }
  };
}
